/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './NotificationBadge.style';

import useAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  layoutClass?: string,
  variant?: typeof small,
};

const useStyles = createUseStyles(styles);

const NotificationBadge = ({ layoutClass, variant }: Props): React.Node => {
  /*
   |------------------------------------------------------------------------------
   | Hooks
   |------------------------------------------------------------------------------
   */

  const [accentColor] = useAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor });

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-small']]: variant === small,
  });

  /*
   |------------------------------------------------------------------------------
   | Elements
   |------------------------------------------------------------------------------
   */

  return <span className={rootClasses} />;
};

export const small = Symbol();

export default compose(React.memo)(NotificationBadge);
